<template>
  <div class="read-page">
    <!-- 页面背景长图 -->
    <img style="width: 100%" src="../../assets/image/download/read/index.jpg" alt="" />

    <!-- 视频展示区 -->
    <div class="video-div">
      <video
        controls
        loop
        poster="../../assets/image/download/read/poster.jpg"
        src="../../assets/image/download/read/movie.mp4"
      ></video>
    </div>

    <!-- 顶部下载按钮 -->
    <button class="headerButton animated animation-count pulse" @click="downloadApp">立即下载</button>

    <!-- 微信内非 iOS 的引导遮罩 -->
    <section class="mask">
      <img src="../../assets/image/download/mask.png" />
    </section>

    <!-- 底部下载按钮 -->
    <button class="footerButton animated animation-count pulse" @click="downloadApp">立即下载</button>
  </div>
</template>

<script>
import { track, downloadApp as download } from "./common";

// 倍速阅读 App 下载地址
const IOS_URL =
  "https://apps.apple.com/cn/app/%E5%80%8D%E9%80%9F%E9%98%85%E8%AF%BB/id1538908266";
const ANDROID_PACKAGE = "com.eletell.lecture";

export default {
  name: "BsydDownload",
  data() {
    return {
      pageId: "2021030405",
      IdF: window.location.href,
    };
  },
  methods: {
    downloadApp() {
      // 带 ttf 参数的推广链接使用独立埋点 id
      if (this.IdF.indexOf("ttf") > -1) {
        this.pageId = "2021030406";
        track(this.pageId);
      }
      this.isWeiXin();
    },
    isWeiXin() {
      const ua = window.navigator.userAgent.toLowerCase();
      const inWeixin = ua.indexOf("micromessenger") > -1;

      // 微信内也直接跳转：iOS 去 App Store，安卓下载安装包；非 iOS 的微信再弹引导遮罩
      download({
        iosUrl: IOS_URL,
        androidPackage: ANDROID_PACKAGE,
        wechatMask: false,
      });
      if (inWeixin && !/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        document.querySelector(".mask").style.display = "block";
      }
      return inWeixin;
    },
  },
  mounted() {
    // 带 ttf 参数：进入页面即上报一次埋点
    if (this.IdF.indexOf("ttf") > -1) {
      track(this.pageId);
    }
  },
};
</script>

<style scoped>
.read-page {
  position: relative;
}
img {
  display: block;
}
.video-div {
  position: absolute;
  left: 50%;
  top: 171.3vw;
  width: 78.7vw;
  margin-left: -39.35vw;
  overflow: hidden;
}
.video-div video {
  width: 100%;
  height: 100%;
}
.headerButton,
.footerButton {
  position: absolute;
  left: 50%;
  height: 12.96vw;
  line-height: 12.96vw;
  border: none;
  border-radius: 6.48vw;
  font-size: 4.26vw;
  font-weight: 700;
  color: #fff;
  background: #3cb560;
}
.headerButton {
  top: 125vw;
  width: 48.6vw;
  margin-left: -24.3vw;
}
.footerButton {
  /* 底部留出备案信息区，按钮不遮挡 */
  bottom: 30vw;
  width: 74.07vw;
  margin-left: -37.04vw;
}
.mask {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.mask img {
  position: absolute;
  top: 2vw;
  right: 2vw;
  width: 75%;
}
.animation-count {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
</style>
